import { render, staticRenderFns } from "./CompetitionEntry.vue?vue&type=template&id=34ae15a0&scoped=true&"
import script from "./CompetitionEntry.vue?vue&type=script&lang=js&"
export * from "./CompetitionEntry.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionEntry.vue?vue&type=style&index=0&id=34ae15a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae15a0",
  null
  
)

export default component.exports